// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-Snackbar-styles--errorMessage--UTTHr {
  white-space: pre-wrap;
}

.src-components-Snackbar-styles--errorButton--AusMB {
  display: inline-block;
  border: 0 !important;
  outline: 0;
  margin: 0;
  margin: initial;
  padding: 0;
  padding: initial;
  background-color: transparent;
  font-weight: 400;
  text-align: left;
  cursor: pointer;
  color: #9fdfff;
  margin-top: 10px;
}

@media screen and (min-width: 768px) {

.src-components-Snackbar-styles--errorButton--AusMB {
    white-space: nowrap;
}
  }

.src-components-Snackbar-styles--errorButton--AusMB:hover,.src-components-Snackbar-styles--errorButton--AusMB:focus {
    color: #9fdfff;
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/Snackbar/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,UAAU;EACV,SAAe;EAAf,eAAe;EACf,UAAgB;EAAhB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAUlB;;AARE;;AAbF;IAcI,mBAAmB;AAOvB;EANE;;AAEA;IAEE,cAAc;EAChB","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.errorMessage {\n  white-space: pre-wrap;\n}\n\n.errorButton {\n  display: inline-block;\n  border: 0 !important;\n  outline: 0;\n  margin: initial;\n  padding: initial;\n  background-color: transparent;\n  font-weight: 400;\n  text-align: left;\n  cursor: pointer;\n  color: #9fdfff;\n  margin-top: 10px;\n\n  @media (--desktop) {\n    white-space: nowrap;\n  }\n\n  &:hover,\n  &:focus {\n    color: #9fdfff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `src-components-Snackbar-styles--errorMessage--UTTHr`,
	"errorButton": `src-components-Snackbar-styles--errorButton--AusMB`
};
module.exports = ___CSS_LOADER_EXPORT___;
